import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useResponsive } from '../hooks/useResponsive';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import fondpropos1 from '../fondpropos1.png';
import coeurs from '../coeurs.png';
import {
    FaUser, FaEnvelope, FaLock, FaEye, FaEyeSlash,
    FaShieldAlt, FaVenusMars, FaQuoteLeft,
    FaRegCommentDots, FaSearch, FaRegHeart
} from 'react-icons/fa';
import { GoShieldCheck } from 'react-icons/go';
import { AiOutlineHeart } from 'react-icons/ai';
import { MdOutlineLock } from 'react-icons/md';

const Register = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [gender, setGender] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPwd, setShowPwd] = useState(false);
    const { register } = useAuth();
    const navigate = useNavigate();
    const { isSmall, isMobile, isTablet } = useResponsive();

    // Validation email
    const validerEmail = (email) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(email);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        // ── Validations côté client ──
        if (!validerEmail(email)) {
            setError('Veuillez entrer une adresse email valide (ex: nom@domaine.com)');
            return;
        }

        if (password.length < 6) {
            setError('Le mot de passe doit contenir au moins 6 caractères');
            return;
        }

        if (!gender) {
            setError('Veuillez sélectionner votre genre');
            return;
        }

        setLoading(true);
        try {
            await register(email, password, gender);
            setSuccess('Inscription réussie. Connectez-vous et renseignez votre profil, puis envoyez-le à l\'examen.');
            setTimeout(() => navigate('/login'), 10000);
        } catch (err) {
            setError(err.response?.data?.message || 'Erreur lors de l\'inscription');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ fontFamily: 'Arial, sans-serif', overflowX: 'hidden', backgroundColor: '#fff' }}>

            <Navbar />

            {/* ═══════════ HERO — fond rosé unique + image coin haut-droit ═══════════ */}
            <section style={{
                position: 'relative',
                backgroundColor: '#fdf2f8',
                overflow: 'hidden',
                minHeight: isMobile ? 'auto' : '640px',
            }}>
                {/* Image lanterne + roses dans le coin haut-droit (masque dégradé) */}
                {!isMobile && (
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        width: isTablet ? '50%' : '52%',
                        height: isTablet ? '48%' : '52%',
                        backgroundImage: `url(${fondpropos1})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        zIndex: 1,
                        WebkitMaskImage: 'linear-gradient(to bottom, black 65%, transparent 100%), linear-gradient(to left, black 70%, transparent 100%)',
                        WebkitMaskComposite: 'source-in',
                        maskImage: 'linear-gradient(to bottom, black 65%, transparent 100%), linear-gradient(to left, black 70%, transparent 100%)',
                        maskComposite: 'intersect',
                    }} />
                )}

                {/* Contenu : colonne gauche (titre + formulaire) + card droite */}
                <div style={{
                    position: 'relative', zIndex: 2,
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    maxWidth: '1200px', margin: '0 auto',
                }}>
                    {/* ── Colonne gauche : titre EXTÉRIEUR + carte formulaire ── */}
                    <div style={{
                        flex: isMobile ? 'none' : '0 0 40%',
                        padding: isSmall ? '24px 16px' : isMobile ? '32px 20px' : isTablet ? '40px 32px' : '48px 48px',
                        display: 'flex', flexDirection: 'column', justifyContent: 'center',
                    }}>
                        <div style={{ maxWidth: '480px', width: '100%', margin: '0 auto' }}>

                            {/* Titre + sous-texte — DIRECTEMENT sur le fond rose */}
                            <p style={{ color: '#c0306a', fontSize: '11px', fontWeight: '700', letterSpacing: '3px', textTransform: 'uppercase', marginBottom: '8px', marginTop: 0 }}>CRÉER UN COMPTE</p>
                            <h1 style={{
                                color: '#1a0010', fontWeight: '700',
                                fontSize: isSmall ? '28px' : isMobile ? '32px' : '38px',
                                lineHeight: '1.2', marginBottom: '12px', marginTop: 0,
                                fontFamily: 'Cormorant Garamond, serif',
                            }}>
                                Commencez votre recherche{' '}
                                <span style={{ color: '#c0306a', whiteSpace: 'nowrap' }}>
                                    en toute sérénité
                                    <img src={coeurs} alt="" style={{ height: isMobile ? '40px' : '50px', verticalAlign: 'middle', marginLeft: '-6px' }} />
                                </span>
                            </h1>
                            <p style={{ color: '#666', fontSize: '13px', lineHeight: '1.7', marginBottom: '24px', marginTop: 0 }}>
                                Rejoignez une communauté bienveillante et éthique,<br />et faites le premier pas vers une union bénie.
                            </p>

                            {/* Carte blanche — UNIQUEMENT le formulaire */}
                            <div style={{
                                backgroundColor: '#ffffff',
                                borderRadius: '20px',
                                boxShadow: '0 8px 40px rgba(120,24,64,0.10)',
                                padding: isSmall ? '24px 20px' : isMobile ? '28px 24px' : '32px 32px',
                            }}>
                                {error && (
                                    <div style={{ backgroundColor: '#ffe0e0', color: '#c00', padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', fontSize: '13px' }}>
                                        {error}
                                    </div>
                                )}
                                {success && (
                                    <div style={{ backgroundColor: '#f0fff0', color: '#1a6a1a', padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', fontSize: '13px' }}>
                                        {success}
                                    </div>
                                )}

                                <form onSubmit={handleSubmit}>
                                    {/* Email */}
                                    <div style={{ marginBottom: '16px' }}>
                                        <label style={{ display: 'block', color: '#1a0010', fontSize: '13px', fontWeight: '600', marginBottom: '7px' }}>Adresse email</label>
                                        <div style={{ position: 'relative' }}>
                                            <FaEnvelope style={{ position: 'absolute', left: '13px', top: '50%', transform: 'translateY(-50%)', color: '#c0306a' }} size={13} />
                                            <input
                                                type="email"
                                                value={email}
                                                onChange={e => setEmail(e.target.value)}
                                                placeholder="Entrez votre adresse e-mail"
                                                required
                                                pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}"
                                                title="Adresse email invalide (ex: nom@domaine.com)"
                                                style={{ width: '100%', padding: '11px 14px 11px 36px', border: '1.5px solid #eedde6', borderRadius: '8px', fontSize: '13px', outline: 'none', boxSizing: 'border-box', color: '#333', backgroundColor: '#fff' }}
                                            />
                                        </div>
                                    </div>

                                    {/* Mot de passe */}
                                    <div style={{ marginBottom: '16px' }}>
                                        <label style={{ display: 'block', color: '#1a0010', fontSize: '13px', fontWeight: '600', marginBottom: '7px' }}>Mot de passe</label>
                                        <div style={{ position: 'relative' }}>
                                            <FaLock style={{ position: 'absolute', left: '13px', top: '50%', transform: 'translateY(-50%)', color: '#c0306a' }} size={13} />
                                            <input
                                                type={showPwd ? 'text' : 'password'}
                                                value={password}
                                                onChange={e => setPassword(e.target.value)}
                                                placeholder="Choisissez un mot de passe"
                                                required
                                                minLength={6}
                                                style={{ width: '100%', padding: '11px 38px 11px 36px', border: '1.5px solid #eedde6', borderRadius: '8px', fontSize: '13px', outline: 'none', boxSizing: 'border-box', color: '#333', backgroundColor: '#fff' }}
                                            />
                                            <button type="button" onClick={() => setShowPwd(!showPwd)} style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#aaa', padding: 0 }}>
                                                {showPwd ? <FaEyeSlash size={14} /> : <FaEye size={14} />}
                                            </button>
                                        </div>
                                    </div>

                                    {/* Genre */}
                                    <div style={{ marginBottom: '20px' }}>
                                        <label style={{ display: 'block', color: '#1a0010', fontSize: '13px', fontWeight: '600', marginBottom: '7px' }}>Je suis</label>
                                        <div style={{ position: 'relative' }}>
                                            <FaVenusMars style={{ position: 'absolute', left: '13px', top: '50%', transform: 'translateY(-50%)', color: '#c0306a' }} size={13} />
                                            <select
                                                value={gender}
                                                onChange={e => setGender(e.target.value)}
                                                required
                                                style={{ width: '100%', padding: '11px 14px 11px 36px', border: '1.5px solid #eedde6', borderRadius: '8px', fontSize: '13px', outline: 'none', boxSizing: 'border-box', color: gender ? '#333' : '#aaa', backgroundColor: '#fff', appearance: 'none', cursor: 'pointer' }}
                                            >
                                                <option value="">Choisir...</option>
                                                <option value="homme">Un frère</option>
                                                <option value="femme">Une sœur</option>
                                            </select>
                                        </div>
                                    </div>

                                    {/* Bouton inscription */}
                                    <button type="submit" disabled={loading} style={{ width: '100%', padding: '13px', background: 'linear-gradient(135deg, #3d0820, #781840)', color: 'white', border: 'none', borderRadius: '8px', fontSize: '15px', cursor: 'pointer', fontWeight: '600', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', marginBottom: '16px', boxShadow: '0 4px 16px rgba(120,24,64,0.3)', fontFamily: 'Arial, sans-serif' }}>
                                        <FaUser size={14} /> {loading ? 'Inscription...' : 'Créer mon compte'}
                                    </button>


                                    <p style={{ textAlign: 'center', color: '#666', fontSize: '13px', margin: 0 }}>
                                        Vous avez déjà un compte ?{' '}
                                        <Link to="/login" style={{ color: '#c0306a', fontWeight: '600', textDecoration: 'none' }}>Se connecter</Link>
                                    </p>
                                </form>
                            </div>
                        </div>
                    </div>

                    {/* ── Colonne droite : card "Pourquoi créer un compte ?" + citation ── */}
                    <div style={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        padding: isMobile ? '8px 20px 32px' : isTablet ? '40px 24px 48px' : '48px 48px 56px',
                        margin: isMobile ? '40px 16px 20px' : '48px 48px 0px',
                    }}>
                        <div style={{
                            width: '100%', maxWidth: '420px',
                            backgroundColor: 'white',
                            borderRadius: '16px',
                            padding: isTablet ? '24px' : '34px',
                            boxShadow: '0 8px 32px rgba(192,48,106,0.12)',
                        }}>
                            <h2 style={{
                                color: '#1a0010',
                                fontSize: isTablet ? '20px' : '24px',
                                fontWeight: '700', marginBottom: '24px', marginTop: 0,
                                fontFamily: 'Cormorant Garamond, serif',
                                textAlign: 'center',
                            }}>
                                Pourquoi créer un compte ?
                            </h2>
                            {[
                                { icon: <GoShieldCheck size={18} color="#781840" />, title: 'Accès complet', text: 'Profitez de toutes les fonctionnalités de la plateforme pour trouver votre moitié en toute confiance.' },
                                { icon: <FaRegCommentDots size={16} color="#781840" />, title: 'Échanges sécurisés', text: 'Communiquez avec des membres vérifiés dans un cadre éthique et respectueux.' },
                                { icon: <FaSearch size={16} color="#781840" />, title: 'Recherche avancée', text: 'Trouvez des profils compatibles selon vos critères, vos valeurs et vos objectifs de mariage.' },
                                { icon: <FaRegHeart size={16} color="#781840" />, title: 'Accompagnement bienveillant', text: 'Bénéficiez de conseils, d\'articles et de rappels pour vous guider à chaque étape.' },
                            ].map((item, i) => (
                                <div key={i} style={{
                                    display: 'flex', gap: '14px',
                                    marginBottom: '18px',
                                    alignItems: 'flex-start',
                                }}>
                                    <div style={{
                                        flexShrink: 0, width: '40px', height: '40px',
                                        borderRadius: '50%',
                                        backgroundColor: 'rgba(192,48,106,0.08)',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    }}>
                                        {item.icon}
                                    </div>
                                    <div>
                                        <p style={{ color: '#1a0010', fontSize: '14px', fontWeight: '700', margin: '0 0 3px 0' }}>{item.title}</p>
                                        <p style={{ color: '#666', fontSize: '12px', lineHeight: '1.6', margin: 0 }}>{item.text}</p>
                                    </div>
                                </div>
                            ))}

                            {/* Citation coranique */}
                            <div style={{
                                backgroundColor: '#fdf2f8',
                                borderRadius: '12px',
                                padding: '20px 22px',
                                marginTop: '8px',
                            }}>
                                <FaQuoteLeft size={18} color="#c0306a" style={{ marginBottom: '10px' }} />
                                <p style={{ color: '#5a4450', fontSize: '13px', lineHeight: '1.7', fontStyle: 'italic', margin: '0 0 12px 0' }}>
                                    Et parmi Ses signes, Il a créé pour vous des épouses parmi vous-mêmes, afin que vous trouviez auprès d'elles tranquillité, et Il a mis entre vous de l'amour et de la miséricorde.
                                </p>
                                <p style={{ color: '#c0306a', fontSize: '12px', fontWeight: '700', margin: 0 }}>— Sourate Ar-Rûm (30:21)</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ═══════════ 4 BADGES ═══════════ */}
            <section style={{ backgroundColor: '#fdf2f8', padding: isMobile ? '32px 16px' : '48px 24px' }}>
                <div style={{
                    maxWidth: '1080px', margin: '0 auto',
                    backgroundColor: 'white',
                    borderRadius: '20px',
                    boxShadow: '0 1px 6px gray',
                    padding: isMobile ? '24px 16px' : '36px 32px',
                    display: 'grid',
                    gridTemplateColumns: isSmall ? '1fr 1fr' : isMobile ? '1fr 1fr' : 'repeat(4, 1fr)',
                    gap: isSmall ? '20px' : '0px',
                }}>
                    {[
                        { icon: <GoShieldCheck size={24} color="#781840" />, title: 'Éthique islamique', text: "Nos pratiques sont conformes aux enseignements de l'Islam." },
                        { icon: <MdOutlineLock size={24} color="#781840" />, title: 'Confidentialité garantie', text: 'Vos données sont protégées et ne sont jamais partagées.' },
                        { icon: <AiOutlineHeart size={24} color="#781840" />, title: 'Respect & bienveillance', text: 'Une communauté basée sur le respect et la bonne intention.' },
                        { icon: <FaShieldAlt size={24} color="#781840" />, title: 'Profils authentiques', text: 'Des profils vérifiés pour des rencontres sérieuses et sincères.' },
                    ].map((b, i) => (
                        <div key={i} style={{
                            textAlign: 'center',
                            padding: isSmall ? '8px' : '8px 20px',
                            borderRight: (!isMobile && i < 3) ? '1px solid rgba(192,48,106,0.15)' : 'none',
                        }}>
                            <div style={{
                                width: isSmall ? '52px' : '60px',
                                height: isSmall ? '52px' : '60px',
                                borderRadius: '50%',
                                backgroundColor: 'rgba(192,48,106,0.08)',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                margin: '0 auto 14px',
                                boxShadow: '0 2px 12px rgba(192,48,106,0.10)',
                            }}>
                                {b.icon}
                            </div>
                            <h4 style={{ color: '#1a0010', fontSize: isSmall ? '13px' : '14px', fontWeight: '700', marginBottom: '8px', marginTop: 0 }}>{b.title}</h4>
                            <p style={{ color: '#999', fontSize: isSmall ? '11px' : '12px', lineHeight: '1.6', margin: 0 }}>{b.text}</p>
                        </div>
                    ))}
                </div>
            </section>

            <Footer />

        </div>
    );
};

export default Register;